var render = function render(){var _vm=this,_c=_vm._self._c;return _c('empty-state',{staticClass:"no-data-tip",attrs:{"title":_vm.tip,"hint":_vm.hint,"icon":_vm.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }